import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { ProductSubcategoryAddDialogComponent } from '../product-subcategory-add-dialog/product-subcategory-add-dialog.component';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { UtilsService } from 'src/app/core/utils.service';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-product-subcategory-header',
  templateUrl: './product-subcategory-header.component.html',
  styleUrls: ['./product-subcategory-header.component.scss'],
})
export class ProductSubcategoryHeaderComponent {
  @Input() product_category_id: string | undefined | null;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private dialog_service: DialogService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
  ) {}

  onAddClick() {
    this.dialog_service
      .openDialog(ProductSubcategoryAddDialogComponent, {
        product_category_id: this.product_category_id,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  getShrinkedID(): string {
    return this.utils_service.getShrinkedID(this.product_category_id || '-');
  }

  onBackClick(): void {
    this.navigation_service.toProductCategory();
  }
}
